import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";

export const callCredApi = async (payload) => {
  const { data = [] } = await axiosInstanceClient.get(
    `${API.apiConfig}?ServiceName=${payload}`
  );
  return data;
};
